(function () {
  var mobileQuery = window.matchMedia('(max-width: 430px)');
  if (!mobileQuery.matches) return;

  var header = document.querySelector('#header-component');
  if (header) {
    var headerThreshold = header.getBoundingClientRect().bottom + window.scrollY;
    header.style.setProperty('--ww-mobile-header-height', header.offsetHeight + 'px');
    var updateHeader = function () {
      header.classList.toggle('ww-mobile-header-fixed', window.scrollY > headerThreshold);
    };
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('.ww-purchase-trust[open]').forEach(function (panel) {
    panel.removeAttribute('open');
  });

  var imageSelector = 'product-card img[loading="lazy"], collection-card img[loading="lazy"], media-gallery img[loading="lazy"]';
  document.querySelectorAll(imageSelector).forEach(function (image) {
    var frame = image.closest('.product-media, .product-media-container, .collection-card__image');
    if (!frame) return;
    frame.classList.add('ww-mobile-image-loading');
    var reveal = function () {
      frame.classList.add('ww-mobile-image-loaded');
    };
    if (image.complete) reveal();
    else image.addEventListener('load', reveal, { once: true });
  });
})();
